import  React,{ useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardBody, CardHeader, Container, Col, Row, Input, Modal, ModalHeader, ModalBody, Button, ModalFooter, Progress, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Table } from 'reactstrap';
import { uploadData, isCancelError, list } from '@aws-amplify/storage';
import { getCurrentUser, fetchAuthSession  } from 'aws-amplify/auth';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { RiFileCopyLine } from 'react-icons/ri';
import { toast } from 'react-toastify';
import '../../aws-config';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { remove } from '@aws-amplify/storage';
import Icon from '@mdi/react';
import { mdiDeleteForever, mdiFolder, mdiArrowLeft } from '@mdi/js';
import FilePreviewModal from './VideoPlayerModal'; 
import { useDispatch } from 'react-redux';
import { setStorageUsed } from '../../slices/storage/reducer'; // Adjust the path accordingly
import { profiledata } from '../../slices/thunks';
import { useSelector } from "react-redux";
import { components } from 'react-select';
import CustomPagination from '../../Components/Common/CustomPagination';
import { VideoLibraryAPI } from '../../helpers/firebase_helper';
const styles = {

  dragDropArea: {
    border: '2px dashed #ced4da',
    padding: '20px',
    textAlign: 'center',
    borderRadius: '10px',
    cursor: 'pointer',
    position: 'relative',
  },
  uploadLabel: {
    display: 'block',
    cursor: 'pointer',
  },
  icon: {
    fontSize: '2.5rem',
    color: '#ced4da',
  },

};

const VideoLibrary = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [videoToDelete, setVideoToDelete] = useState(null);
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [videosPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [videos, setVideos] = useState([]);
  const [folders, setFolders] = useState([]);
  const [currentPath, setCurrentPath] = useState('');
  const [pathStack, setPathStack] = useState([]);
  const [abortController, setAbortController] = useState(null);
  const [uploadTask, setUploadTask] = useState(null);
  const profileData = useSelector((state) => state.Profile.profileData);
  const [cognito_id, setCognito_id] = useState(null)
  const [showUpgradeButton, setShowUpgradeButton] = useState(false); 
  const navigate = useNavigate();
  const [createFolderModal, setCreateFolderModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');
  const [isCreatingFolder, setIsCreatingFolder] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({});



  const token = localStorage.getItem('token');

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.add('drag-over');
  };
  const toggleDropdown = (videoId) => {
    setDropdownOpen(prevState => ({
      ...prevState,
      [videoId]: !prevState[videoId]
    }));
  };


  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove('drag-over');

  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove('drag-over');
    const droppedFile = e.dataTransfer.files[0];

    if (droppedFile) {
      handleFileChange({ target: { files: [droppedFile] } });
    }
  };

  const toggleModal = () => {
    setModal(!modal);
    if (!modal) {
      setFile(null);
      setUploadProgress(0);
    }
  };
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    setFile(selectedFile);
  };

  const toggleCreateFolderModal = () => {
    setNewFolderName(''); 
    setCreateFolderModal(!createFolderModal);
  };

  const fetchLibraryData = async (prefix = '') => {
    try {
      const user = getCurrentUser();
      const cognito_id = (await user).userId;
      setCognito_id(cognito_id)
      setLoading(true);
      const response = await VideoLibraryAPI.fetchLibraryData(prefix? { prefix } : {});

      if (response && response.status === 'success') {
        const { folders, files } = response?.result;

        setFolders(
          folders.map((folder) => ({
            name: folder.name,
            fullPath: folder.path,
          }))
        )

        setVideos(
          files.map((file) => ({
            file_id: file.file_id,
            video_title: file.filename,
            s3_key: file.key,
            video_size: file.size,
            created_at: file.created_at,
            duration: file.duration, 
            playback_url: file.cdn_url,
            file_type: file.file_type,
          }))
        );
      } else {
        setFolders([]);
        setVideos([]);
      }
    } catch (error) {
      console.error('Error fetching library data:', error);
      toast.error('Error fetching library data.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLibraryData();
  }, [token, profileData]);

  const handleOpenFolder = (folderName) => {
    const newPath = currentPath ? `${currentPath}${folderName}/` : `${folderName}/`;
    setPathStack((prev) => [...prev, currentPath]);
    setCurrentPath(newPath);
    fetchLibraryData(newPath);
  };


  const handleGoBack = () => {
    const previous = pathStack.pop() || '';
    setCurrentPath(previous);
    setPathStack([...pathStack]);
    fetchLibraryData(previous);
  };

  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const handleCreateFolder = async () => {
    if (!newFolderName.trim()) {
      toast.error('Folder name cannot be empty.');
      return;
    }

    setIsCreatingFolder(true);
    try {
      const user = await getCurrentUser();
      const cognito_id = user.userId;
      const folderId = uuidv4();
      const folderPath = currentPath
        ? `protected/${cognito_id}/${currentPath}${newFolderName}/`
        : `protected/${cognito_id}/${newFolderName}/`;

      const task = uploadData({
        path: folderPath,
        data: '', 
      });
      setUploadTask(task);

      const result = await task.result;

      const apiData = {
        file_id: folderId,
        s3_key: result.path,
        filename: newFolderName,
        extension: '',
        content_type: 'application/x-directory',
        file_type: 'folder',
        size_bytes: 0,
        folder_path: folderPath,
      };

      const response = await VideoLibraryAPI.createFileFolder(apiData);
      toast.success(`Folder "${newFolderName}" created successfully!`);
      fetchLibraryData(currentPath); // Refresh the library to show the new folder
      toggleCreateFolderModal();
    } catch (error) {
      console.error('Error creating folder:', error);
      toast.error(error.response?.data?.message || 'Failed to create folder.');
    } finally {
      setIsCreatingFolder(false);
    }
  };

  const handleUpload = async () => {

    const user = await getCurrentUser();
    if (!file) {
      alert('Please select a file to upload');
      return;
    }
    const userData = profileData?.result;

    if (!userData) {
      toast.error('Could not retrieve user profile data.');
      return;
    }

    const { storage_used, storage_quota, max_video_size } = userData;
    const remainingStorageBytes = storage_quota - storage_used;
    const fileSizeInBytes = file.size;

    const remainingStorageFormatted = formatBytes(remainingStorageBytes);
    const fileSizeFormatted = formatBytes(fileSizeInBytes);
    const maxVideoSizeFormatted = formatBytes(max_video_size);

    if (fileSizeInBytes > max_video_size) {
      toast.error(`The selected file exceeds the maximum allowed size of ${maxVideoSizeFormatted}. Please select a smaller file.`);
      return;
    }

    if (fileSizeInBytes > remainingStorageBytes) {
      toast.error(`Not enough storage available. Your remaining storage is ${remainingStorageFormatted} .`);
      setShowUpgradeButton(true);
      return;
    } else {
      setShowUpgradeButton(false);
    }

    const fileId = uuidv4();
    const fileNameWithId = `${fileId}-${file.name}`;
    const originalFileName = file?.name;
    const fileExtension = originalFileName.slice(((originalFileName.lastIndexOf(".") - 1) >>> 0) + 2);
    const fileType = file.type;

    let fileCategory = 'other';
    if (fileType.startsWith('video/')) fileCategory = 'video';
    else if (fileType.startsWith('image/')) fileCategory = 'image';
    else if (fileType.startsWith('audio/')) fileCategory = 'audio';
    else if (fileType === 'application/pdf' || fileType.includes('document')) fileCategory = 'document';

    const folderPath = currentPath ? `/${currentPath.replace(/\/$/, '')}` : '/';

    const controller = new AbortController();
    setAbortController(controller);
    setUploading(true);

    try {

      const task = uploadData({
        path: () => currentPath
          ? `protected/${user.userId}/${currentPath}${fileId}.${fileExtension}`
          : `protected/${user.userId}/${fileId}.${fileExtension}`,
        data: file,
        options: {
          contentType: fileType,
          metadata: {
            name: originalFileName,
          },
          onProgress: ({ transferredBytes, totalBytes }) => {
            if (totalBytes) {
              const percentage = Math.round((transferredBytes / totalBytes) * 100);

              setUploadProgress(percentage);
            }
          },
          signal: controller.signal,
        },
      });
      setUploadTask(task);

      const result = await task.result;
      // console.log('Upload result:', result);
      const apiData = {
        file_id: fileId,
        s3_key: result.path,
        filename: originalFileName,
        extension: fileExtension,
        content_type: fileType,
        file_type: fileCategory,
        size_bytes: fileSizeInBytes,
        folder_path: folderPath,
      };
      const response = await VideoLibraryAPI.createFileFolder(apiData);


      toast.success('File uploaded and data saved successfully!');
      fetchLibraryData();
      toggleModal();
      dispatch(profiledata(cognito_id));
    } catch (error) {
      if ((error.name === 'AbortError') || (isCancelError(error))) {

        toast.info('Upload cancelled');
      } else {
        ;
        toast.error(error);
        if (error.message && error.message.includes('AccessDenied')) {
          console.error('Access denied. Please check your AWS Amplify configuration.');
        }
      }
    } finally {
      setUploading(false);
      setAbortController(null);
    }
  };

  const handleUpgradeClick = () => {
    navigate('/billing/current-plan');
  };

  const handleCancel = () => {
    if (uploadTask) {
      uploadTask.cancel();
      if (abortController) {
        abortController.abort();
      }
      setUploading(false);

    }
    setShowUpgradeButton(false);
    toggleModal();
  };

  const handleDeleteClick = (video) => {

    if (!video || !video.file_id) {
      toast.error('Error: Invalid video selected for deletion.');
      return;
    }
    setVideoToDelete(video);
    toggleDeleteModal();
  };

  const confirmDelete = async () => {
    if (!videoToDelete || !videoToDelete.playback_url) {
      toast.error('Error: No video selected for deletion.');
      return;
    }
    setIsDeleting(true);
    try {
      const user = await getCurrentUser();
      const cognito_id = user.userId;
      const video_id = videoToDelete.file_id;
      const url = videoToDelete.s3_key;
      const s3_key = new URL(videoToDelete.playback_url).pathname.substring(1);


      const deletePayload = {
        s3_key
      };


      const response = await VideoLibraryAPI.deleteFile(deletePayload);

      if (response.status === "success") {
        const path = `protected/${cognito_id}/${url}`;
        const bucket = process.env.REACT_APP_BUCKET_NAME;
        try {
          await remove({
            path: path,
            bucket: bucket,
          });
          toast.success('Video deleted successfully !');
          dispatch(profiledata(cognito_id));

          setVideos((prevVideos) => prevVideos.filter((video) => video.file_id !== video_id));
        } catch (s3Error) {
          console.error('Error deleting video from S3:', s3Error);
          toast.error('Error deleting video from S3.');
        }
      } else {
        console.log(error);
        toast.error('Error deleting video.');
      }
    } catch (error) {
      console.error('Error deleting video:', error);
      toast.error('Error deleting video.');
    } finally {
      setIsDeleting(false);
      toggleDeleteModal();
    }
  };

  const formatDuration = (duration) => {
    if (duration < 1000) {
      return `${duration} ms`;
    } else if (duration >= 1000 && duration < 60000) {
      return `${(duration / 1000).toFixed(2)} s`;
    } else if (duration >= 60000 && duration < 3600000) {
      const minutes = Math.floor(duration / 60000);
      const seconds = Math.floor((duration % 60000) / 1000);
      return `${minutes} . ${seconds} min`;
    } else {
      const hours = Math.floor(duration / 3600000);
      const minutes = Math.floor((duration % 3600000) / 60000);
      return `${hours} . ${minutes} hr`;
    }
  };

  const formatCreatedAt = (utcDateString) => {
    if (!utcDateString) return 'N/A';
    const dateInIST = new Date(utcDateString + 'Z').toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });

    return dateInIST;
  };


  const handleCopy = (url) => {
    navigator.clipboard.writeText(url)
      .then(() => {
        toast.success('URL copied to clipboard!');
      })
      .catch(err => console.error('Failed to copy URL:', err));
  };

  const renderFileIcon = (file) => {
    let iconClass = 'ri-file-line'; 
    let color = '#878a99'; 

    switch (file.file_type) {
      case 'video':
        iconClass = 'ri-video-line';
        color = '#405189'; 
        break;
      case 'image':
        iconClass = 'ri-image-line';
        color = '#299cdb'; 
        break;
      case 'audio':
        iconClass = 'ri-music-2-line';
        color = '#f06548'; 
        break;
      case 'document':
        iconClass = 'ri-file-text-line';
        color = '#f7b84b'; 
        break;
      default:
        break;
    }
    return <i className={`${iconClass} fs-20 me-2`} style={{ color }}></i>;
  };

  const filteredVideos = videos.filter(video =>

    video.video_title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const sortedVideos = filteredVideos.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  const indexOfLastVideo = currentPage * videosPerPage;
  const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
  const currentVideos = sortedVideos.slice(indexOfFirstVideo, indexOfLastVideo);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  document.title = "Media Pulse | Video Library";
  return (
    <div className='page-content'>
      <Container fluid>
        {/* <BreadCrumb title="DAM" pageTitle="" /> */}
        <BreadCrumb
          title="DAM"
          pageTitle="DAM"
          currentPath={currentPath}

          onNavigate={(path) => {
            // console.log("Navigating to:", path);
            setCurrentPath(path);
            fetchLibraryData(path);
          }}
        />
        <Col>
          <Card>
            <CardHeader className="align-items-center">
             
              <div className="mb-3 row">
                <div className="border border-dashed border-end-0 border-start-0 card-body">
                  <Row>
                    <Col md={6}>
                      <div className="search-box ms-2">
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Search for file by name..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </Col>
                    <Col md={6} className="text-end">
                      <div className="d-flex justify-content-end">
                        <button className="btn btn-success" onClick={toggleModal}>
                          <i className="ri-add-line align-bottom me-1"></i> Upload File
                        </button>
                        <button className="btn btn-primary ms-2" onClick={toggleCreateFolderModal}>
                          <i className="ri-folder-add-line align-bottom me-1"></i> Create Folder
                        </button>
                        {currentPath && (
                          <Button color="secondary" className="ms-2" onClick={handleGoBack}>
                            <Icon path={mdiArrowLeft} size={1} /> Back
                          </Button>
                        )}
                      </div>

                    </Col>
                  </Row>
                </div>
              </div>
            </CardHeader>

            <CardBody>
              {loading ? (
                <div className="text-center">Loading...</div>
              ) : (
                <div className="table-responsive">
                  <Table className="table-hover align-middle">
                    <thead className="table-light">
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Size</th>
                        <th scope="col">Duration</th>
                        <th scope="col">Last Modified</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {folders.map((folder) => (
                        <tr key={folder.fullPath} onDoubleClick={() => handleOpenFolder(folder.name)} style={{ cursor: 'pointer' }}>
                          <td>
                            <Icon path={mdiFolder} size={1} color="#FFD700" className="me-2" />
                            {folder.name}
                          </td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                      ))}
                      {currentVideos.map((video) => (
                        <tr key={video.file_id}>
                          <td>
                            {renderFileIcon(video)}
                            <span className="align-middle">{video.video_title}</span>
                          </td>
                          <td>{formatBytes(video.video_size)}</td>
                          <td>{formatDuration(video.duration) || 'N/A'}</td>
                          <td>{formatCreatedAt(video.created_at) || 'N/A'}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              {video.playback_url ? (
                                <FilePreviewModal file={video} renderFileIcon={renderFileIcon} />
                              ) : (
                                <Button variant="link" disabled>
                                  {renderFileIcon(video)}
                                </Button>
                              )}
                              <Dropdown isOpen={dropdownOpen[video.file_id]} toggle={() => toggleDropdown(video.file_id)} direction='down'>
                                <DropdownToggle tag="a" className="btn btn-light btn-icon" role="button">
                                  <i className="ri-more-2-fill"></i>
                                </DropdownToggle>
                                <DropdownMenu container="body" className="dropdown-menu-end">
                                  <DropdownItem onClick={() => handleDeleteClick(video)}>
                                    <i className="ri-delete-bin-5-fill align-bottom me-2 text-muted"></i> Delete
                                  </DropdownItem>
                                  {video.playback_url && (
                                    <DropdownItem onClick={() => handleCopy(video.playback_url)}>
                                      <i className="ri-file-copy-line align-bottom me-2 text-muted"></i> Copy URL
                                    </DropdownItem>
                                  )}
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {folders.length === 0 && filteredVideos.length === 0 && (
                    <div className="text-center p-4">
                      <p>This folder is empty.</p>
                    </div>
                  )}
                </div>
              )}
            </CardBody>
          </Card>
        </Col>

        {/* Pagination */}
        <div className="row g-0 text-center text-sm-start align-items-center mb-3">
          <div className="col-sm-6">
            <p className="mb-sm-0">
              Showing {indexOfFirstVideo + 1} to {Math.min(indexOfLastVideo, filteredVideos.length)} of {filteredVideos.length} entries
            </p>
          </div>

          <div className="col-sm-6">
            <ul className="pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
              <CustomPagination
                totalItems={videos.length}
                itemsPerPage={videosPerPage}
                currentPage={currentPage}
                onPageChange={paginate}
              />
            </ul>
          </div>
        </div>


        <Modal isOpen={modal} toggle={toggleModal} centered backdrop={uploading ? 'static' : true}>
          <ModalBody onDragOver={handleDragOver}
            onDrop={handleDrop}
            onDragLeave={handleDragLeave}
            onDragEnter={handleDragOver}
            style={{ position: 'relative', padding: '20px' }}>
            <div className="upload-container">
              <div className="d-flex justify-content-center ">
                <h3>Upload File</h3>
              </div>
              <Input type="file" onChange={handleFileChange} style={{ display: 'none' }} id="fileInput" />
              <div className="drag-drop-area" style={styles.dragDropArea} >
                <label htmlFor="fileInput" style={styles.uploadLabel}>
                  <div style={styles.icon}>
                    <i className="ri-upload-cloud-2-line display-4 text-muted"></i>
                  </div>
                  <div>
                    <p>Drag and Drop files here</p>
                    <p>-OR-</p>
                    <Button color="success" onClick={() => document.getElementById('fileInput').click()}>Browse Files</Button>
                  </div>
                </label>
                {file && <p>Selected file: {file.name}</p>}
              </div>

              {uploading && (
                <div className="progress-container mt-3">
                  <Progress animated value={uploadProgress} max="100">
                    {uploadProgress}%
                  </Progress>
                </div>
              )}
            </div>
          </ModalBody>


          <ModalFooter className="d-flex justify-content-center">
            <Button color="success" onClick={handleUpload} disabled={!file || uploading}>
              {uploading ? 'Uploading...' : 'Upload'}
            </Button>
            <Button color="danger" onClick={handleCancel}>
              Cancel
            </Button>

            {showUpgradeButton && (
              <Button color="warning" onClick={handleUpgradeClick}>
                Upgrade Plan
              </Button>
            )}
          </ModalFooter>
        </Modal>


        <Modal isOpen={deleteModal} toggle={toggleDeleteModal} centered style={{ maxWidth: '400px', width: '90%' }}>
          <ModalBody className="text-center" >

            <div style={{ fontSize: '3rem', color: '#dc3545' }}>
              <Icon path={mdiDeleteForever} size={3} />
            </div>
            <h2 className="text-danger mt-2 font-weight-bold">Delete Video?</h2>
            <h4 className="mt-3">
              Are you sure, you want to delete this video ?
            </h4>
            <ModalFooter className="justify-content-center mt-4">
              <Button color="white" onClick={toggleDeleteModal} className="me-4" style={{
                border: '2px solid #6691E7',
                color: '#6691E7',
                width: '90px',
              }}>
                Cancel
              </Button>
              <Button color="success" onClick={confirmDelete} style={{ width: '90px' }} disabled={isDeleting}>
                {isDeleting ? 'Deleting...' : 'Delete'}
              </Button>
            </ModalFooter>
          </ModalBody>
        </Modal>

        <Modal isOpen={createFolderModal} toggle={toggleCreateFolderModal} centered>
          <ModalHeader toggle={toggleCreateFolderModal}>Create New Folder</ModalHeader>
          <ModalBody>
            <Input
              type="text"
              placeholder="Enter folder name"
              value={newFolderName}
              onChange={(e) => setNewFolderName(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleCreateFolderModal}>Cancel</Button>
            <Button color="primary" onClick={handleCreateFolder} disabled={isCreatingFolder}>{isCreatingFolder ? 'Creating...' : 'Create'}</Button>
          </ModalFooter>
        </Modal>


      </Container>

    </div>
  );
};



export default VideoLibrary;